export type MembershipTierKey = "basic" | "premium";
export type ProgramKey = "rot";
export type IncludedCallSource = "grow-premium" | "rot-program";
export type PaymentStage = "registration" | "balance" | "recurring";

export interface MembershipPlanConfig {
  key: MembershipTierKey;
  label: string;
  pricePerMonth: number;
  includesMaterial: boolean;
  includedCallsPerMonth: number;
  description: string;
}

export interface RotProgramConfig {
  key: ProgramKey;
  label: string;
  registrationFee: number;
  fullPrice: number;
  moduleCount: number;
  durationWeeks: number;
  prepModuleAvailableImmediately: boolean;
  includedCallsPerWeek: number;
  waitlistEnabled: boolean;
  seatLimit?: number;
}

export interface CohortAccessState {
  registered: boolean;
  depositPaid: boolean;
  fullyPaid: boolean;
  started: boolean;
  completed: boolean;
}

export const GROW_BASIC_PLAN: MembershipPlanConfig = {
  key: "basic",
  label: "GROW Basic",
  pricePerMonth: 249,
  includesMaterial: true,
  includedCallsPerMonth: 0,
  description: "Månadsvis material i hälsoportalen. Självständigt arbete utan samtal."
};

export const GROW_PREMIUM_PLAN: MembershipPlanConfig = {
  key: "premium",
  label: "GROW Premium",
  pricePerMonth: 1055,
  includesMaterial: true,
  includedCallsPerMonth: 1,
  description: "Allt material i hälsoportalen plus ett inkluderat samtal per månad."
};

export const ROT_PROGRAM: RotProgramConfig = {
  key: "rot",
  label: "ROT-programmet",
  registrationFee: 2000,
  fullPrice: 0,
  moduleCount: 12,
  durationWeeks: 12,
  prepModuleAvailableImmediately: true,
  includedCallsPerWeek: 1,
  waitlistEnabled: true
};
